import React from 'react'
import BgShadow from "./Shadow"
import PaternHorizontal from '@/components/pattern/Paternhorizontal';

const Pattern = ({ classNameBase = "", className = "", disableShadow, disablePatttern }: { classNameBase?: string, className?: string, disableShadow?: boolean, disablePatttern?: boolean }) => {
    return (
        <div className={(disablePatttern ? '' : '') + " relative -z-10 " + classNameBase}>
            {!disablePatttern &&
                <div className={' fixed left-0 top-0 w-full'}>
                    <PaternHorizontal className={className + ' h-screen w-full'} />
                </div>
            }
            {!disableShadow &&
                <div className=' absolute left-0 top-0 w-full h-full'>
                    <div className=' flex items-center justify-between'>
                        <div className=''>
                            <BgShadow color1='text-dynamic' color2="text-dynamic" />
                        </div>
                        <div className=' opacity-25'>
                            <BgShadow color1='text-dynamic' color2="text-dynamic" />
                        </div>
                        <div className=' opacity-75'>
                            <BgShadow color1='text-dynamic' color2="text-dynamic" />
                        </div>
                    </div>
                    <div className=' flex items-center justify-end flex-1'>
                        <div className=' opacity-25'>
                            <BgShadow color1='text-dynamic' color2="text-dynamic" />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Pattern
